

const BannerItem = [
    {
        id: 1,
        title: "Biofeedback",
        cover: require("../../Assets/Banner/BannerItem/biofeedback_logo_imagefor-circle.jpg")
    },
    {
        id: 2,
        title: "Neurofeedback",
        cover: require("../../Assets/Banner/BannerItem/neurofeedback_logo_imagefor-circle.jpg")
    },
    {
        id: 3,
        title: "NeurotrackerX",
        cover: require("../../Assets/Banner/BannerItem/Brain.png")
    },
    {
        id: 4,
        title: "PunchSensor",
        cover: require("../../Assets/Banner/BannerItem/Unlock.jpg")
    },
    {
        id: 5,
        title: " Sports Vision Training",
        cover: require("../../Assets/Banner/BannerItem/realtime.jpg")
    },
    {
        id: 6,
        title: " Motion capture technology",
        cover: require("../../Assets/Banner/BannerItem/Motion capture technology.jpg")
    },
]

export default BannerItem